module.exports = __webpack_public_path__ + "assets/img/Logitech-G-Landing-page-w720.f8cdf642.jpg";